// The design system's motion tokens (theme.css › MOTION), for JavaScript animations.
const milliseconds = value => parseFloat(value) * (value.trim().endsWith("ms") ? 1 : 1000)

export function motion(name) {
  const style = getComputedStyle(document.documentElement)
  const easing = style.getPropertyValue(`--ease-${name}`).trim()
  return {
    duration: milliseconds(style.getPropertyValue(`--duration-${name}`)),
    easing: CSS.supports("transition-timing-function", easing) ? easing : "ease-out"
  }
}

export const reducedMotion = () => matchMedia("(prefers-reduced-motion: reduce)").matches

// A box springs from one height to another.
export function spring(element, from, to) {
  if (from === to) return

  element.animate([ { height: `${from}px`, overflow: "hidden" }, { height: `${to}px`, overflow: "hidden" } ], motion("spring"))
}

// Content fades in at the pace of its movement, so it never shows before it has moved.
export function enter(element, transform, delay = 0) {
  element.animate([ { opacity: 0 }, { opacity: 1 } ], { ...motion("fade"), delay, fill: "backwards" })
  element.animate([ { transform }, { transform: "none" } ], { ...motion("spring"), delay, fill: "backwards" })
}

// A row scrolls to a position on a token's curve: browsers only scroll smoothly on their own,
// slow-starting curve. Snapping pauses while it moves, or it would pull the row back each frame.
export function glide(element, left, name = "smooth") {
  cancelAnimationFrame(element.glide)
  const to = Math.min(left, element.scrollWidth - element.clientWidth)
  if (reducedMotion()) return element.scrollTo({ left: to })

  const { duration, easing } = motion(name)
  const points = easing.slice(easing.indexOf("(") + 1, -1).split(",").map(parseFloat)
  const ease = t => {
    const at = t * (points.length - 1), below = Math.floor(at)
    return points[below] + ((points[below + 1] ?? 1) - points[below]) * (at - below)
  }
  const from = element.scrollLeft, start = performance.now()
  element.style.scrollSnapType = "none"

  const step = now => {
    const t = Math.min(1, (now - start) / duration)
    element.scrollLeft = from + (to - from) * ease(t)
    if (t < 1) element.glide = requestAnimationFrame(step)
    else element.style.scrollSnapType = ""
  }
  element.glide = requestAnimationFrame(step)
}
